// Import SCSS
import './../scss/app.scss';

// Bootstrap
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// import Custom JS
import './custom-js';

// Event calendar
import EventCalendar from './calendar.js';

window['EventCalendar'] = EventCalendar;
